export const SERVICE_PLAN_CONFIG: Record<string, { group: string; label: string; range: [number, number] }> = {
  surrogacy_has_embryo: { group: "单助孕", label: "已有胚胎", range: [1, 12] },
  surrogacy_transfer_embryo: { group: "单助孕", label: "转入胚胎", range: [13, 24] },
  ivf_self: { group: "试管助孕", label: "自精自卵", range: [25, 48] },
  ivf_donor: { group: "试管助孕", label: "捐赠助孕", range: [49, 76] },
  embryo_transport: { group: "胚胎转运", label: "胚胎转出", range: [77, 83] },
  fertility_preservation: { group: "生育力保存", label: "生育力保存", range: [84, 89] },
};

export const EXPENSE_TYPES = [
  { key: "employee_commission", label: "员工提成" },
  { key: "channel_commission", label: "渠道佣金" },
  { key: "other", label: "其他支出" },
];

export function formatServicePlan(planKey: string | null | undefined): string {
  if (!planKey) return "-";
  const cfg = SERVICE_PLAN_CONFIG[planKey];
  if (!cfg) return planKey;
  return `${cfg.group} · ${cfg.label}`;
}

export interface NotificationTemplate {
  id: string;
  label: string;
  title: string;
  content: string;
}

export const DEFAULT_TEMPLATES: NotificationTemplate[] = [
  { id: "custom", label: "自定义", title: "", content: "" },
  { id: "reminder", label: "阶段提醒", title: "阶段提醒", content: "您好，您当前正处于【{stageName}】阶段，请按照顾问指导完成相关准备事项。如有疑问，请随时联系您的专属顾问。" },
  { id: "start", label: "即将开始", title: "即将开始", content: "温馨提醒：您的【{stageName}】即将开始，请提前安排好行程和相关准备工作。祝您一切顺利！" },
  { id: "complete", label: "阶段完成", title: "阶段完成", content: "恭喜！您的【{stageName}】已顺利完成。接下来我们将进入下一阶段，如有任何问题请随时咨询。" },
  { id: "urgent", label: "紧急事项", title: "紧急提醒", content: "紧急提醒：您在【{stageName}】阶段有重要事项需要尽快处理，请尽快联系您的专属顾问确认后续安排。" },
];

export type ExpenseEntry = { receivable: number; received: number; usd_receivable: number; usd_received: number };

export function parseExpenseData(raw: any): Record<string, ExpenseEntry> {
  if (!raw || typeof raw !== "object") return {};
  const result: Record<string, ExpenseEntry> = {};
  for (const t of EXPENSE_TYPES) {
    const data = raw[t.key];
    result[t.key] = {
      receivable: parseFloat(data?.receivable || 0),
      received: parseFloat(data?.received || 0),
      usd_receivable: parseFloat(data?.usd_receivable || 0),
      usd_received: parseFloat(data?.usd_received || 0),
    };
  }
  return result;
}